import * as R from 'ramda'
import { useReducer, useCallback } from 'react'
import effects from 'app/effects/effects'

const SET_TRANSLATION_LANGUAGE = 'SET_TRANSLATION_LANGUAGE'
const START_LOADING = 'START_LOADING'
const SET_TRANSLATION_LANGUAGE_ERROR = 'SET_TRANSLATION_LANGUAGE_ERROR'

const initialState = {
  languages: [],
  isLoading: false,
  isShowLanguages: false,
  error: undefined,
}

const mapping = (arr) => {
  return arr.map((item) => ({
    ...(item.translation ? item.translation : {}),
    body: item.translation ? item.translation.description : undefined,
    language: {
      code: item.code,
      id: item.id,
      name: item.name,
      nativeName: item.nativeName,
      sortOrder: item.sort_order,
      status: item.status,
      subscriberCount: item.subscriberCount,
      isTranslated: item.isTranslated,
    },
  }))
}

function reducer(state, action) {
  switch (action.type) {
    case SET_TRANSLATION_LANGUAGE: {
      return R.mergeRight(state, {
        languages: mapping(action.languages),
        isLoading: false,
        error: undefined,
      })
    }
    case SET_TRANSLATION_LANGUAGE_ERROR:
      return R.mergeRight(state, {
        languages: undefined,
        isLoading: false,
        error: action.error,
      })
    case START_LOADING:
      return R.mergeRight(state, {
        isLoading: true,
        error: undefined,
      })
    default:
      return state
  }
}

export const useTranslationLanguageNotification = (notificationId) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const loadTranslationLanguage = useCallback(() => {
    if (state.isLoading) return
    dispatch({ type: START_LOADING })
    return effects.apis
      .getTranslationLanguageById({ notificationId: notificationId })
      .then(
        R.compose(
          dispatch,
          R.mergeRight({ type: SET_TRANSLATION_LANGUAGE }),
          R.objOf('languages'),
        ),
      )
      .catch(
        R.compose(
          dispatch,
          R.mergeRight({ type: SET_TRANSLATION_LANGUAGE_ERROR }),
          R.objOf('error'),
        ),
      )
  }, [notificationId, dispatch, state.isLoading])

  const arrayToObject = (arr = [], key = '') => {
    if (!R.isNil(arr)) {
      return arr.reduce((obj, item) => {
        obj[item.language[key]] = item
        return obj
      }, [])
    }
  }

  const languageSorting = R.sortWith([
    R.descend(R.path(['language', 'isTranslated'])),
    R.ascend(R.path(['language', 'name'])),
  ])

  const fetchTranslationLanguage = () => {
    loadTranslationLanguage()
  }

  return {
    fetchTranslationLanguage,
    languages: arrayToObject(state.languages, 'id'),
    languagesOptions: languageSorting(state.languages),
    isLoading: state.isLoading,
  }
}
